// extracted by mini-css-extract-plugin
export default {"drawer":"drawer__Ogb_u","drawer-slide":"drawer-slide__tjNiB","drawer-blur":"drawer-blur__x8pVH"};